import React from "react";
import { Alert, Avatar, Box, Button, Container, IconButton, Paper, Snackbar, Stack, TextField, Tooltip, Typography } from "@mui/material";
import { useProfile } from "../../../common/useProfile";
import { Save } from "@mui/icons-material";
import Service from "../../../../util/Service";
import { ACCESS_TOKEN, time_cache } from "../../../login/Login";

export default function MyAccountPanel() {
    const prof = useProfile();
    const [avatar, setAvatar] = React.useState();
    const [passwordAtual, setPasswordAtual]= React.useState('');
    const [password, setPassword]= React.useState('');
    const [confirPass, setConfirPass]= React.useState('');

    const [open, setOpen] = React.useState(false);

    const [openSalvaAvatar, setOpenSalvaAvatar] = React.useState(false);

    const [msg, setMsg] = React.useState({
        severity: "success",
        msg: "Sucesso!"
    });

    React.useEffect(()=>{
        if( prof.profile && prof.profile.avatar ){
            setAvatar( prof.profile.avatar )
        }
    },[prof.profile])

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
    };

    if (!prof.isOk) {
        return (
            <div style={{
                textAlign: 'center',
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
                // width: '100vw',
                height: '75vh'
            }}
            >
                <Typography variant="h4">Aguarde!</Typography>
            </div>
        )
    }
    function handleSalvaAvatar(){
        console.log('>>>handleSalvaAvatar<<<');
        const dado = {
            id: prof.profile.id,
            avatar: avatar
        }
        Service.POST("/api/security/user/avatar", dado).then( r =>{
            console.log( r );
            if( r.success){
                sessionStorage.removeItem("profile");
                window.location.reload();
            }
        })
    }
    function convertImageToBase64FromFile(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();

            reader.onload = () => {
                resolve(reader.result); // reader.result contains the Base64 data URL
            };

            reader.onerror = (error) => {
                reject(error);
            };

            reader.readAsDataURL(file); // Read the file as a data URL
        });
    }
    function hasProvider(){
        if( !prof.profile.provider ) return false;
        if( prof.profile.provider.length === 0 ) return false;
           
        return true;
    }
    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            if (file.size / 1000 > 200) {
                setOpen(true);
                setMsg({
                    severity: 'error',
                    msg: 'A imagem ultrapassou o limite de 200kb'
                })
            }
            convertImageToBase64FromFile(file)
                .then((base64String) => {
                    // console.log('Base64 String:', base64String);
                    // You can now use this base64String, e.g., to display the image:
                    // document.getElementById('previewImage').src = base64String;
                    setAvatar(base64String);
                    setOpenSalvaAvatar(true)
                })
                .catch((error) => {
                    console.error('Error converting image:', error);
                });
        }
    };
    function handleTrocaSenha(){
        console.log(passwordAtual, password, confirPass );
        const user = {
            id: prof.profile.id,
            password: password,
        }
        console.log( user);
        Service.LOGIN("/api/security/trocaSenha", user).then( r=>{
            if (!r.accessToken) {
                if (r.status === 403) {
                //   setPasswordError(true)
                //   setPasswordErrorMessage("Login invalido")
                  return;
                }
              }
              localStorage.setItem(ACCESS_TOKEN, r.accessToken);
              setTimeout(() => {
                const page = localStorage.getItem("page");
                window.location.href = (page && page != '/login') ? page : "/";  
              }, 800);
              
              montaProfile();
        })
    }
    function montaProfile() {
        Service.GET("/api/security/profile").then(ret => {      
          ret.timeout = time_cache + (new Date().getTime());
          sessionStorage.setItem("profile", JSON.stringify(ret))      
        }).catch((e) => {      
          console.error(e);
          
        });
      }
    
    return (
        <Container sx={{ padding: 2 }} maxWidth="md">
            <Paper sx={{ width: '100%', mb: 2, p: 2 }}>
                <Stack>
                    <Stack direction="row" spacing={2}>

                        <IconButton onClick={() => document.getElementById("file").click()}>
                            {avatar && <Avatar alt={prof.profile.nome} src={avatar} />}
                            {!avatar &&
                                <Avatar alt={prof.profile.nome} >
                                    {prof.profile.nome.charAt(0)}
                                </Avatar>}
                        </IconButton>
                        {openSalvaAvatar && 
                        <Tooltip title="Salvar Avatar">
                            <IconButton
                                color="primary"
                                onClick={handleSalvaAvatar}
                            >
                                <Save />
                            </IconButton>
                        </Tooltip>}

                        <Typography sx={{ paddingTop: "20px" }}>
                            <strong>Nome: </strong>{    prof.profile.nome},
                            <strong> Login: </strong>{  prof.profile.login},
                            
                            <strong> Email: </strong>{  prof.profile.email}
                        </Typography>
                    </Stack>
                    {!hasProvider() && 
                    <React.Fragment>
                        <Typography variant="h6" gutterBottom>
                            Trocar senha
                        </Typography>
                        <TextField autoComplete="off"
                            label="Senha atual"
                            width="50"
                            type='password'
                            size='small'
                            variant="standard"
                            value={passwordAtual} onChange={(e)=>setPasswordAtual(e.target.value)}
                        />
                        <TextField autoComplete="off"
                            label="Nova senha"
                            width="50"
                            type='password'
                            size='small'
                            variant="standard"
                            value={password} onChange={(e)=>setPassword(e.target.value)}
                        />
                        <TextField autoComplete="off"
                            label="Confirmar senha"
                            width="50"
                            type='password'
                            size='small'
                            variant="standard"
                            value={confirPass} onChange={(e)=>setConfirPass(e.target.value)}
                        />
                    </React.Fragment>}
                    <Box sx={{ p:2, mt:2, textAlign:'center'}}>
                        <Button variant="contained" onClick={handleTrocaSenha}>Trocar Senha</Button>
                    </Box>
                </Stack>
            </Paper>
            <input
                id="file"
                type="file"
                onChange={handleFileChange}
                style={{ display: "none" }}
                accept=".jpeg, .jpg, .png"
            />
            <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
                <Alert
                    onClose={handleClose}
                    severity={msg.severity}
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {msg.msg}
                </Alert>
            </Snackbar>
        </Container>

    )
}